import React, { useContext } from "react";
import { Select, MenuItem } from "@material-ui/core";
import Extent from "@arcgis/core/geometry/Extent";
import "./GeoSelector.scss";
import { MapContext } from "../../context/MapContext";
import geometries from "../../constants/geometries";

function GeoSelector(props) {
  const [mapObject] = useContext(MapContext);
  const { handleOnChange, selectedGeometry, selections } = props;

  const handleSelectChange = (e) => {
    const selectedGeometry = geometries.find((geo) => geo.name === e.target.value);
    mapObject.view.goTo(new Extent(selectedGeometry.extent));
    handleOnChange(e.target.value);
  };

  // if selections are provided, only allow those that match
  const choices = geometries.filter(
    (g) => !selections || selections.includes(g.name)
  );

  return (
    <div className="geoSelector">
      <div className="selectInstructions">Select Geography:</div>
      <Select
        onChange={handleSelectChange}
        id="geoSelect"
        variant="outlined"
        value={selectedGeometry}
      >
        {choices.map((geo) => (
          <MenuItem key={geo.name} value={geo.name}>
            {geo.name}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
}

export default GeoSelector;
